// extracted by mini-css-extract-plugin
export default {"questionsDetails":"BorrowerFrequentlyAskedQuestions_questionsDetails__5DgLE","h4":"BorrowerFrequentlyAskedQuestions_h4__5OreQ"};